// One person = one Intercom contact and one FullStory record across Classic,
// NextGen and the Acceleration Point platform (#194). The API issues
// `personId` once IDENTITY_EMAIL_HMAC_KEY is set and signs the Intercom
// identity JWT itself (#23, `intercomUserJwt`); until the key is set NextGen
// keeps today's hashid (`user.id` = kwelloUserId). The browser never computes
// an id or a signature.
import { UserModel } from 'common/models/user.model';

interface TrackingProject {
  moduleProjectID?: string;
  projectClientName?: string;
  projectDisplayName?: string;
}

export const trackingUserId = (user: UserModel) => user.personId ?? user.id;

export const intercomMessengerConfig = (
  user: UserModel,
  activeProject: TrackingProject | undefined,
  now: number
) => ({
  api_base: 'https://api-iam.intercom.io',
  app_id: 'y588ttna',
  company: {
    company_id: 'unknown', // Followup ticket to expose this in user data
    name: user.companyName,
  },
  custom_launcher_selector: '#intercom_help_center',
  created_at: now,
  currentProjectId: activeProject?.moduleProjectID ?? 'unknown',
  email: user.email,
  name: user.externalName,
  projectClientName: activeProject?.projectClientName ?? 'unknown',
  projectDisplayName: activeProject?.projectDisplayName ?? 'unknown',
  userClientId: 'unknown', // Followup ticket to expose this in user data
  userClientName: user.companyName,
  user_id: trackingUserId(user),
  ...(user.intercomUserJwt ? { intercom_user_jwt: user.intercomUserJwt } : {}),
});

export const fullStoryIdentity = (user: UserModel, activeProject: TrackingProject | undefined) => ({
  uid: trackingUserId(user),
  properties: {
    displayName: user.externalName,
    email: user.email,
    userId: trackingUserId(user),
    projectClientName: activeProject?.projectClientName ?? 'unknown',
    projectDisplayName: activeProject?.projectDisplayName ?? 'unknown',
    companyName: user.companyName,
  },
});
